import React from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
import type { JobStatus } from '@vidly/types';

interface ProcessingStepperProps {
  status: JobStatus;
}

export const ProcessingStepper: React.FC<ProcessingStepperProps> = ({ status }) => {
  const steps = [
    { key: 'validating', label: 'Inspección técnica', desc: 'Validación de códec con FFprobe' },
    { key: 'transcribing', label: 'Extracción de audio', desc: 'Separación de pista de voz' },
    { key: 'planning', label: 'Planificación con IA', desc: 'Gemini analiza momentos clave' },
    { key: 'review_pending', label: 'Listo para revisión', desc: 'Preparando editor interactivo' }
  ];

  const getStepState = (stepKey: string) => {
    const order = ['pending', 'uploading', 'validating', 'transcribing', 'planning', 'review_pending', 'rendering', 'completed'];
    const currentIndex = order.indexOf(status);
    const stepIndex = order.indexOf(stepKey);

    if (currentIndex > stepIndex) return 'completed';
    if (currentIndex === stepIndex) return 'active';
    return 'pending';
  };

  return (
    <div className="py-8 max-w-md mx-auto text-left space-y-6">
      <div className="text-center space-y-1">
        <h3 className="text-base font-semibold text-white">
          Procesando tu vídeo
        </h3>
        <p className="text-xs text-zinc-500">
          Analizando la estructura y el contenido hablado con IA.
        </p>
      </div>

      <div className="p-4 rounded-xl border border-zinc-800 bg-zinc-900/30 space-y-3">
        {steps.map((step, idx) => {
          const state = getStepState(step.key);
          return (
            <div
              key={idx}
              className={`flex items-center justify-between p-2.5 rounded-lg transition-all ${
                state === 'active'
                  ? 'bg-zinc-800/60 border border-zinc-700/60'
                  : 'text-zinc-400'
              }`}
            >
              <div className="space-y-0.5">
                <p className={`text-xs font-medium ${state === 'active' ? 'text-white' : state === 'completed' ? 'text-zinc-300' : 'text-zinc-500'}`}>
                  {step.label}
                </p>
                <p className="text-[11px] text-zinc-500">{step.desc}</p>
              </div>

              <div>
                {state === 'completed' && <CheckCircle2 className="w-4 h-4 text-emerald-400" />}
                {state === 'active' && <Loader2 className="w-4 h-4 text-zinc-200 animate-spin" />}
                {state === 'pending' && <span className="w-1.5 h-1.5 rounded-full bg-zinc-800 block mr-1" />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
